import PropTypes from 'prop-types';
import React from 'react';
import Avatar from './Avatar';
import DisplayName from './DisplayName';
import { getComponentClasses } from '@99designs/utils/app';
import deprecated from '../lib/deprecated';

export default class User extends React.Component {
    avatar() {
        let variations = this.props.avatarVariations;
        if (this.props.avatarSize) {
            deprecated(
                `avatarSize is deprecated, prefer avatarVariations={[\'${this.props.avatarSize}\']}`
            );
            variations = variations.concat(this.props.avatarSize);
        }
        return (
            <span className="user__avatar">
                <Avatar
                    user={this.props.user}
                    isLinked={this.props.isLinked}
                    size={this.props.avatarSize}
                    variations={variations}
                />
            </span>
        );
    }

    displayName() {
        return (
            <span className="user__display-name">
                <DisplayName
                    user={this.props.user}
                    isLinked={this.props.isLinked}
                    variations={this.props.displayNameVariations}
                    isTruncated={this.props.isTruncated}
                    limit={this.props.limit}
                />
            </span>
        );
    }

    render() {
        const classes = getComponentClasses('user', this.props.variations);

        return (
            <span className={classes}>
                {this.avatar()}
                {this.displayName()}
            </span>
        );
    }
}

User.propTypes = {
    user: PropTypes.shape({
        name: PropTypes.string.isRequired,
        profileUrl: PropTypes.string,
        avatarUrl: PropTypes.string,
        isActive: PropTypes.bool,
    }),
    variations: PropTypes.array,
    displayNameVariations: PropTypes.array,
    avatarVariations: PropTypes.array,
    avatarSize: PropTypes.oneOf(['extra-small', 'small', 'medium']),
    isTruncated: PropTypes.bool,
    isLinked: PropTypes.bool,
    limit: PropTypes.number,
};

User.defaultProps = {
    variations: [],
    displayNameVariations: [],
    avatarVariations: ['extra-small'],
    isTruncated: false,
    isLinked: true,
    limit: 20,
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/User.jsx